module.exports = __webpack_public_path__ + "assets/eeea4aa04d3eadf2c2a6862e5e929c9b.mp3";